import React, { Fragment, useEffect, useState } from 'react'
import Heading from '../../component/Heading/Heading'
import { baseURL, CompanyProfileData, countriesList, MenuProps } from '../../content/content'
import InputComponent from '../../component/input/Input'
import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material'
import profileImg from "../../assets/icons/profile-image.svg"
import editIcon from "../../assets/icons/edit-2.svg"
import deleteIcon from "../../assets/icons/trush-2.svg"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import CommonButton from '../../component/button/Button'
import { getCompanyDetails, updateCompanyDetail } from '../../services/admin-services/companyDetailsServices'
import Toast from '../../component/toastify/Index'
import "../../styles/pages/company/profile.scss";
import { useTranslation } from 'react-i18next';
import { getCustomerProfileDetails } from '../../services/customer-services/customerProfileService'
import { getAdminProfileDetails } from '../../services/admin-services/AdminprofileServices'
import { jwtDecode } from 'jwt-decode'
import { useCommonContext } from '../../context/common'
import { Grid } from '@mui/material';
import { REQUIRES_RHB_NUMBER } from '../customer/company/CustomerCompany'

const Profile = () => {
    const { t } = useTranslation();
    const [previewUrl, setPreviewUrl] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [formData, setFormData] = useState({})
    const [generalFields, setGeneralFields] = useState(CompanyProfileData.Generally_tax)
    const [errors, setErrors] = useState({});
    const { selectedLanguage } = useCommonContext();

    const gelAllCompanyDetails = async () => {
        const response = await getCompanyDetails();
        setGeneralFields(CompanyProfileData.Generally_tax)

        if (response?.isSuccess) {

            const { superAdminCompany, ...rest } = response;
            const { address, bankInformation, ...companyDetails } = superAdminCompany;

            const newStateData = response.superAdminCompany.geschaftsfuhrer.reduce((acc, value, index) => {
                acc[`geschaftsfuhrer_${index + 1}`] = value;
                return acc;
            }, {});

            const flattenedData = {
                ...rest,
                ...companyDetails,
                ...address,
                ...bankInformation,
                ...newStateData
            };
            flattenedData.profileImage && setProfileImage(flattenedData.profileImage)
            setFormData(flattenedData);

            if (!response?.superAdminCompany?.geschaftsfuhrer) return;
            if (response.superAdminCompany.legalForm && response.superAdminCompany.legalForm !== "Einzelunternehmen" && response.superAdminCompany.legalForm !== "GbR") {
                setGeneralFields(() => [
                    ...CompanyProfileData.Generally_tax,
                    {
                        label: "Geschaftsfuhrer", id: 1, type: "text", name: "geschaftsfuhrer1", translationKey: 'company_geschaftsfuhrer', placeholderTranslationKey: 'company_placeholder_geschaftsfuhrer'
                    },
                ]);
            }
            if (response.superAdminCompany.legalForm && REQUIRES_RHB_NUMBER.has(response.superAdminCompany.legalForm)) {
                setGeneralFields((old) => [...old,
                    { label: "HRB Nummer", type: "text", name: "hrbNumber", translationKey: 'company_hrb_number', placeholderTranslationKey: 'company_placeholder_hrb_number' },

                ]);
            }
            if (response.superAdminCompany.legalForm === "Einzelunternehmen" || response.superAdminCompany.legalForm === "GbR") {
                const newField = {
                    label: "Inhaber",
                    type: "text",
                    name: `inhaber`,
                    translationKey: 'company_inhaber',
                    placeholderTranslationKey: 'company_placeholder_inhaber'
                };
                setGeneralFields((prevFields) => [...prevFields, newField]);
            }

            const newData = response?.superAdminCompany?.geschaftsfuhrer?.map((item, index) => {
                const count = index + 1;
                const newField = {
                    label: "Geschaftsfuhrer",
                    type: "text",
                    name: `geschaftsfuhrer_${count}`,
                    id: new Date().getTime() + index,
                    count: count,
                    translationKey: 'company_geschaftsfuhrer',
                    placeholderTranslationKey: 'company_placeholder_geschaftsfuhrer'
                };

                return newField
                // return newField;
            });
            setGeneralFields((prevState) => {
                return [...prevState, ...newData];
            });
        }
    };

    const convertCompanyData = (data) => {
        const formData = new FormData();
        const geschaftsfuhrer = []

        for (const key in data) {
            if (key.includes("geschaftsfuhrer_")) {
                geschaftsfuhrer.push(data[key])
            }
        }
        // Append simple fields
        formData.append('name', data.name);
        formData.append('geschaftsfuhrer', JSON.stringify(geschaftsfuhrer));
        formData.append('legalForm', data?.legalForm || '');
        formData.append('email', data?.email);
        formData.append('faxNumber', data?.faxNumber);
        formData.append('amtgericht', data?.amtgericht);
        formData.append('website', data?.website || '');
        formData.append('mobileNumber', data?.mobileNumber || '');
        formData.append('country', data?.country || '');
        formData.append('taxNumber', data?.taxNumber || '');
        formData.append('vatIdentificationNumber', data?.vatIdentificationNumber || '');

        if (data?.inhaber) {
            formData.append('inhaber', data?.inhaber || '');
        }

        if (data?.geschaftsfuhrer1) {
            formData.append('geschaftsfuhrer1', data?.geschaftsfuhrer1);
        }

        if (data?.hrbNumber) {
            formData.append('hrbNumber', data?.hrbNumber || '');
        }

        if (!profileImage) {
            formData.append('profileImage', data?.profileImage || '');
        }

        // Append address object
        formData.append('address[streetNo]', data?.streetNo || '');
        formData.append('address[city]', data?.city || '');
        formData.append('address[pincode]', data?.pincode || 0);

        // Append bank information object
        formData.append('bankInformation[bank]', data?.bank || '');
        formData.append('bankInformation[iban]', data?.iban || '');
        formData.append('bankInformation[bic]', data?.bic || '');

        return formData;
    };

    useEffect(() => {
        gelAllCompanyDetails();
    }, [])

    const handleChange = (e) => {

        const { name, value } = e.target;

        if (name === "legalForm") {
            setGeneralFields(() => [...CompanyProfileData?.Generally_tax]);
            for (const key in formData) {
                if (key.includes("geschaftsfuhrer_")) {
                    const finedField = CompanyProfileData?.Generally_tax?.find((items) => items.name === key);

                    if (!finedField) {
                        delete formData[key];
                    }
                }
            }

            if (value === "Einzelunternehmen" || value === "GbR") {
                const newField = {
                    label: "Inhaber",
                    type: "text",
                    name: `inhaber`,
                    translationKey: 'company_inhaber',
                    placeholderTranslationKey: 'company_placeholder_inhaber'
                };
                setGeneralFields((prevFields) => [...prevFields, newField]);
            } else {
                setGeneralFields(() => [
                    ...CompanyProfileData.Generally_tax,
                    { label: "Geschaftsfuhrer", id: 1, type: "text", name: "geschaftsfuhrer1", translationKey: 'company_geschaftsfuhrer', placeholderTranslationKey: 'company_placeholder_geschaftsfuhrer' },
                ]);
            }
            if (REQUIRES_RHB_NUMBER.has(value)) {
                setGeneralFields((old) => [...old,
                    { label: "HRB Nummer", type: "text", name: "hrbNumber", translationKey: 'company_hrb_number', placeholderTranslationKey: 'company_placeholder_hrb_number' },

            ]);
        }
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        } else if (name.includes("geschaftsfuhrer")) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));

        } else if (name === "profileImage") {
            setProfileImage(null)
            setFormData((prevData) => ({
                ...prevData,
                [name]: e.target.files[0],

            }));

            if (e.target.files[0]) {
                setPreviewUrl(URL.createObjectURL(e.target.files[0]));
            }

        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    }
    const handleSaveCompanyDetails = async (e) => {

        for (const key in formData) {
            if (key.includes("geschaftsfuhrer_")) {
                const finedField = generalFields.find((items) => items.name === key);

                if (!finedField) {
                    delete formData[key];
                }
            }
        }
        e.preventDefault();
        if (!validate()) return;
        const data = convertCompanyData(formData)
        const response = await updateCompanyDetail(data)
        if (response?.isSuccess) {
            Toast(response?.message, "success");
            gelAllCompanyDetails();
        }
    }

    const validate = () => {
        let valid = true;
        const newErrors = {};

        CompanyProfileData?.Generally?.forEach((item) => {
            if (!formData[item.name]?.trim() && item.name !== "faxNumber") {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            } else if (item.name == "faxNumber" && formData[item.name] && !/^[\d\W]+$/.test(formData[item.name])) {
                newErrors[item.name] = `${t("common_is_valid_faNumber_format")}`
                valid = false;
            }
        });

        generalFields?.forEach((item) => {
            if (!formData[item.name]?.trim()) {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            }
        });

        CompanyProfileData?.Bank_Information.forEach((item) => {
            if (!formData[item.name]?.trim()) {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            } else if (item.name == "iban" && !/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(formData[item.name])) {
                newErrors[item.name] = `${t("common_is_valid_iban_format")}`;
                valid = false;
            } else if (item.name == "bic" && !/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/.test(formData[item.name])) {
                newErrors[item.name] = `${t("common_is_valid_bic_format")}`;
                valid = false;
            }
        });

        if (!formData["streetNo"]?.trim()) {
            newErrors["streetNo"] = `${t('company_street')} ${t("common_is_required")}`;
            valid = false;
        }
        else if (!formData["pincode"]) {
            newErrors["pincode"] = `${t('company_pincode')} ${t("common_is_required")}`;
            valid = false;
        }
        else if (!formData["city"]?.trim()) {
            newErrors["city"] = `${t('company_city')} ${t("common_is_required")}`;
            valid = false;

        } else if (
            formData["email"] && !/^\S+@\S+\.\S+$/.test(formData["email"])) {
            newErrors["email"] = `${t('common_is_valid_email')}`;
            valid = false;
        }
        else if (formData["mobileNumber"] && formData["mobileNumber"].length > 20) {
            newErrors["mobileNumber"] = `${t('common_is_valid_mobile_number')}`;
            valid = false;
        }

        CompanyProfileData?.Generally_tax?.forEach((item) => {
            if (!formData[item.name]?.trim()) {
                newErrors[item.name] = `${t(item.translationKey)} ${t("common_is_required")}`;
                valid = false;
            }
        });

        // if (!formData["profileImage"]) {
        //     newErrors["profileImage"] = `${t('common_is_valid_profile_picture')}`
        //     valid = false;
        // }

        setErrors(newErrors);
        return valid;
    };

    const handleAddField = () => {

        const newField = {
            label: "Geschaftsfuhrer",
            type: "text",
            name: `geschaftsfuhrer_${generalFields[generalFields.length - 1].count ? generalFields[generalFields.length - 1].count + 1 : 1}`,
            id: new Date().getTime(),
            count: generalFields[generalFields.length - 1].count ? generalFields[generalFields.length - 1].count + 1 : 1,
            translationKey: 'company_geschaftsfuhrer',
            placeholderTranslationKey: 'company_placeholder_geschaftsfuhrer'
        };
        setGeneralFields((prevFields) => [...prevFields, newField]);
    };

    const handleDeleteField = (deletedField) => {
        const dataClone = [...generalFields]
        const newFieldData = dataClone.filter((item) => item.id !== deletedField.id)
        setGeneralFields(newFieldData);
        delete formData[deletedField["name"]]
        setFormData({ ...formData })
    };

    const handleDelete = () => {
        setProfileImage(null);
        setPreviewUrl(null);
        setFormData((prevData) => ({
            ...prevData,
            profileImage: null,
        }));
    };

    return (
        <div className='copony-profile'>
            <Heading text={t('module_company_details')} className="copony-profile-heading" />
            <div>
                <form className='company-profile-form' onSubmit={handleSaveCompanyDetails}>
                    <div>
                        <div className='copony-profile-subheading'>
                            <h3 className='Generally'>{t('company_general')}</h3>
                        </div>
                        <Grid container>
                            <Grid container rowSpacing={5} columnSpacing={3} >
                                <Grid item size={{ xs: 12, lg: 8 }} className='generally-col-one'>
                                    <Grid container columnSpacing={3} rowSpacing={2}>
                                        {CompanyProfileData?.Generally?.map((item, index) => (
                                            <Grid item size={{ xs: 12, md: 6 }} key={index} className='select-label' >
                                                {
                                                    item.type === "select" && item.label === "Country" ? (
                                                        <FormControl
                                                            fullWidth
                                                            error={!!errors[item.name]}
                                                        >
                                                            <FormLabel
                                                                className="label"
                                                                sx={{
                                                                    paddingTop: "1.25rem",
                                                                    paddingBottom: "10px",
                                                                    display: "inline-block",
                                                                    color: "#000",
                                                                }}
                                                            >
                                                                {t(item.translationKey)}
                                                            </FormLabel>
                                                            <Select
                                                                className="select-input"
                                                                fullWidth
                                                                value={formData[item?.name] || ""}
                                                                onChange={(event) => {
                                                                    handleChange(event);
                                                                    setFormData({
                                                                        ...formData,
                                                                        [item?.name]: event.target.value,
                                                                    });
                                                                }}
                                                                displayEmpty
                                                                inputProps={{
                                                                    name: item?.name,
                                                                    IconComponent: () => (
                                                                        <span
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                paddingRight: "10px",
                                                                            }}
                                                                        >
                                                                            <ExpandMoreIcon
                                                                                sx={{ fontSize: "30px", color: "#33333399" }}
                                                                            />
                                                                        </span>
                                                                    ),
                                                                }}
                                                                style={{
                                                                    padding: "0",
                                                                    borderRadius: "10px",
                                                                    border: "1px solid #e3e3e391",
                                                                }}
                                                                MenuProps={MenuProps}
                                                            >
                                                                {/* Placeholder */}
                                                                <MenuItem value="" sx={{ fontFamily: "Poppins" }} disabled>
                                                                    {t(item.placeholderTranslationKey)}
                                                                </MenuItem>

                                                                {/* Options */}
                                                                {countriesList?.find(alpha => alpha.alpha === selectedLanguage)?.list?.map((option, i) => (
                                                                    <MenuItem key={i} value={option.alpha3} sx={{ fontFamily: "Poppins" }}>
                                                                        {option.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            {errors[item.name] && (
                                                                <FormHelperText sx={{ margin: "0", marginTop: "8px", color: "#d32f2f", fontSize: "14px", fontFamily: "Poppins" }}>{errors[item.name]}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    ) :
                                                        item.type === "select" ? (
                                                            <FormControl
                                                                fullWidth
                                                                error={!!errors[item.name]}
                                                            >
                                                                <FormLabel
                                                                    className="label"
                                                                    sx={{
                                                                        paddingTop: "1.25rem",
                                                                        paddingBottom: "10px",
                                                                        display: "inline-block",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    {t(item.translationKey)}
                                                                </FormLabel>
                                                                <Select
                                                                    className="select-input"
                                                                    fullWidth
                                                                    value={formData[item?.name] || ""}
                                                                    onChange={(event) => {
                                                                        handleChange(event);
                                                                        setFormData({
                                                                            ...formData,
                                                                            [item?.name]: event.target.value,
                                                                        });
                                                                    }}
                                                                    displayEmpty
                                                                    inputProps={{
                                                                        name: item?.name,
                                                                        IconComponent: () => (
                                                                            <span
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    paddingRight: "10px",
                                                                                }}
                                                                            >
                                                                                <ExpandMoreIcon
                                                                                    sx={{ fontSize: "30px", color: "#33333399" }}
                                                                                />
                                                                            </span>
                                                                        ),
                                                                    }}
                                                                    style={{
                                                                        padding: "0",
                                                                        borderRadius: "10px",
                                                                        border: "1px solid #e3e3e391",
                                                                    }}
                                                                >
                                                                    {/* Placeholder */}
                                                                    <MenuItem value="" disabled>
                                                                        {t(item.placeholderTranslationKey)}
                                                                    </MenuItem>

                                                                    {/* Options */}
                                                                    {item?.options?.map((option, i) => (
                                                                        <MenuItem key={i} value={option.value}>
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                                {errors[item.name] && (
                                                                    <FormHelperText sx={{ margin: "0", marginTop: "8px", color: "#d32f2f", fontSize: "14px", fontFamily: "Poppins" }}>{errors[item.name]}</FormHelperText>
                                                                )}
                                                            </FormControl>
                                                        ) : (
                                                            <InputComponent
                                                                borderColor="#E3E3E3"
                                                                border="2px solid #E3E3E3"
                                                                bordersize="1"
                                                                padding="10px 12px"
                                                                placeholder={t(item.placeholderTranslationKey)}
                                                                type={item.type}
                                                                label={t(item.translationKey)}
                                                                className="user-input"
                                                                name={item?.name}
                                                                error={!!errors[item.name]}
                                                                helperText={errors[item.name]}
                                                                value={formData[item?.name] || ""}
                                                                onChange={handleChange}
                                                            />
                                                        )
                                                }
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                                <Grid item size={{ xs: 12, lg: 4 }} className='generally-col-two'>
                                    <div className='flex justify-center'>
                                        <div className='company-data'>
                                            <div className='company-logos w-100'>
                                                <label htmlFor="upload-profile-image" className="cursor-pointer">
                                                    <img src={previewUrl ? previewUrl : profileImage ? `${baseURL}/upload/company/superAdmin/${profileImage}` : profileImg} alt="company-image" className='w-100' />
                                                </label>

                                                <div className='action-icon'>
                                                    <div className='edit-icon'>
                                                        <label htmlFor="upload-profile-image" className="cursor-pointer">
                                                            <img src={editIcon} alt="edit icon" className='profile-action-icons edit' /></label>
                                                    </div>
                                                    <div className='delete-icon'>
                                                        <img src={deleteIcon} alt="edit icon" className='profile-action-icons delete' onClick={handleDelete} />
                                                    </div>
                                                </div>
                                            </div>
                                            <InputComponent
                                                type="file"
                                                bordersize="0"
                                                id="upload-profile-image"
                                                className="hidden"
                                                accept="image/*"
                                                onChange={handleChange}
                                                name="profileImage"
                                                error={!!errors["profileImage"]}
                                                helperText={errors["profileImage"]}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container rowSpacing={2} columnSpacing={3} className="generally-col-three">
                                {generalFields?.map((item, index) => (
                                    item.id ? (
                                        <React.Fragment key={item?.id}>
                                            <Grid item size={{ xs: 12 }}>
                                                <Grid container spacing={3}>
                                                    <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                                                        <div className='gernal-field'>
                                                            <InputComponent
                                                                borderColor="#E3E3E3"
                                                                border="2px solid #E3E3E3"
                                                                bordersize="1"
                                                                padding="10px 12px"
                                                                placeholder={t(item.placeholderTranslationKey)}
                                                                type={item.type}
                                                                label={t(item.translationKey)}
                                                                className="user-input w-100"
                                                                name={item?.name}
                                                                error={!!errors[item.name]}
                                                                helperText={errors[item.name]}
                                                                value={formData[item?.name] || ""}
                                                                onChange={handleChange}

                                                            />

                                                            {/* Remove Field Icon */}
                                                            {item.id && item.id !== 1 && (
                                                                <div className='remove-field-icon'>
                                                                    <img
                                                                        src={deleteIcon}
                                                                        alt="delete icon"
                                                                        onClick={() => handleDeleteField(item)}
                                                                    />
                                                                </div>
                                                            )}

                                                            {/* Add Field Icon */}

                                                            {formData.legalForm &&
                                                                item.id &&
                                                                generalFields[generalFields.length - 1]?.id === item.id
                                                                ? (
                                                                    <div className='add-field-icons'>
                                                                        <ControlPointIcon onClick={handleAddField} />
                                                                    </div>
                                                                )
                                                                :
                                                                item.geschaftsfuhrer1 && <div className='add-field-icons'>
                                                                    <ControlPointIcon onClick={handleAddField} className='add-geschaftsfuhrer-icon' />
                                                                </div>

                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                        : <Fragment>
                                            <Grid item size={{ xs: 12, md: 6, lg: 4 }} key={index} >
                                                <div className='gernal-field'>
                                                    <InputComponent
                                                        borderColor="#E3E3E3"
                                                        bordersize="1"
                                                        border="2px solid #E3E3E3"
                                                        padding="10px 12px"
                                                        placeholder={t(item.placeholderTranslationKey)}
                                                        type={item.type}
                                                        label={t(item.translationKey)}
                                                        className="user-input w-100"
                                                        name={item?.name}
                                                        error={!!errors[item.name]}
                                                        helperText={errors[item.name]}
                                                        value={formData[item?.name] || ""}
                                                        onChange={handleChange}
                                                    />
                                                    {item.id && <div className='remove-field-icon'>
                                                        <img src={deleteIcon} alt="delete icon" className='delete-icon-size' onClick={() => handleDeleteField(item.id)} />
                                                    </div>
                                                    }

                                                    {formData.legalForm && item.id && generalFields[generalFields.length - 1].id === item.id && formData.Geschäftsführe === formData.legalForm !== "Einzelunternehmen" && formData.legalForm !== "GbR" &&
                                                        <div className='add-field-icons' >
                                                            <ControlPointIcon onClick={handleAddField} className='cursor-pointer' />

                                                        </div>
                                                    }

                                                    {formData.legalForm && item.id && generalFields[generalFields.length - 1].id === item.id && formData.Geschäftsführe === formData.legalForm !== "Einzelunternehmen" && formData.legalForm !== "GbR" &&
                                                        <div className='add-field-icons' >
                                                            <ControlPointIcon onClick={handleAddField} />
                                                        </div>
                                                    }
                                                </div>
                                            </Grid>
                                        </Fragment>
                                ))
                                }
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <div className='copony-profile-subheading'>
                            <h3 className='address'>{t('company_address')}</h3>
                        </div>

                        <Grid container rowSpacing={2} columnSpacing={3}>
                            {CompanyProfileData?.Address?.map((item, index) => (
                                <Grid item size={{ xs: 12, md: 6, lg: 4 }} key={index}>
                                    <InputComponent
                                        borderColor="E3E3E3"
                                        border="2px solid #E3E3E3"
                                        padding="10px 12px"
                                        placeholder={t(item.placeholderTranslationKey)}
                                        onChange={handleChange}
                                        type={item.type}
                                        label={t(item.translationKey) + ":"}
                                        className="user-input"
                                        name={item?.name}
                                        error={!!errors[item.name]}
                                        helperText={errors[item.name]}
                                        value={formData[item?.name] || ""}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </div>

                    <div>
                        <div className='copony-profile-subheading'>
                            <h3 className='address'>{t('company_bank_Information')}</h3>
                        </div>
                        <Grid container rowSpacing={2} columnSpacing={3}>
                            {CompanyProfileData["Bank_Information"]?.map((item, index) => (
                                <Grid item size={{ xs: 12, md: 6, lg: 4 }} key={index}>
                                    <InputComponent
                                        borderColor="E3E3E3"
                                        border="2px solid #E3E3E3"
                                        padding="10px 12px"
                                        placeholder={t(item.placeholderTranslationKey)}
                                        type={item.type}
                                        onChange={handleChange}
                                        label={t(item.translationKey) + ":"}
                                        className="user-input"
                                        name={item?.name}
                                        error={!!errors[item.name]}
                                        helperText={errors[item.name]}
                                        value={formData[item?.name] || ""}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </div>

                    <div className='company-details-save-btn flex justify-center'>
                        <CommonButton type="submit" className="profile-details-seve-btn button-border-radius" text={t('company_save_company_details')} />
                    </div>
                </form>
            </div >
        </div>
    )
}

export default Profile